import StepProgress from './StepProgress.vue';

export default StepProgress;
